module.exports = __webpack_public_path__ + "img/conny-f-stage5-sulking.5ed41c43.png";